import iconMarker from '../../img/remove-marker.svg';

import { Button } from "antd"

interface IButtonMarker {
    removeMarker: () => void;
}

const ButtonMarker = (props: IButtonMarker) => {
    const {removeMarker} = props;

    return (<Button style={{margin:"5px"}} onClick={removeMarker}><img src={iconMarker} style={{width:"20px"}}></img> </Button>)

}

export default ButtonMarker